module.exports = "# Batch Image Resize Tool\r\n\r\nResize, compress, or convert multiple images at once\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/BulkResize/bulk-resize-header.md
// module id = 1136
// module chunks = 0